// extracted by mini-css-extract-plugin
var _1 = "Ez4ld";
var _2 = "DDBW9";
export { _1 as "button", _2 as "inverse" }
